import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { apiInstance } from "../../../api/api";

// register the necessary chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const IncomeExpenseDailyChart = () => {
    const [chartData, setChartData] = useState({labels: [], datasets: []});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [month, setMonth] = useState(new Date().getMonth() + 1); //default to the current month
    const [year, setYear] = useState(new Date().getFullYear());


    // function to fetch data based on the selected month and year
    const fetchData = async (selectedMonth, selectedYear) => {
        try {
            setLoading(true);
            setError(null);
            const response = await apiInstance.get(`/transactions/income_expense_daily/?month=${selectedMonth}&year=${selectedYear}`);
            const data = response.data;

            // set the chart data
            setChartData({
                labels: data.days.map(day => `${day}`), // labels for each day of the month
                datasets: [
                    {
                        label: "Income",
                        backgroundColor: "rgba(75, 192, 192, 0.8)",
                        borderColor: "rgba(75, 192, 192, 1)",
                        borderWidth: 1,
                        data: data.income
                    },
                    {
                        label: "Expense",
                        backgroundColor: "rgba(255, 99, 132, 0.8)",
                        borderColor: "rgba(255, 99, 132, 1)",
                        borderWidth: 1,
                        data: data.expense,
                    }
                ]
            });
            setLoading(false);
        } catch (error) {
            console.error('Error fetching chart data:', error);
            setError('Failed to load data');
            setLoading(false);
        }
    };

    // fetch data when the component mounts or when the month and year change
    useEffect(() => {
        fetchData(month, year);
    }, [month, year]);

    // handle the month change
    const handleMonthChange = (e) => {
        setMonth(e.target.value);
    };

    // handle the year change
    const handleYearChange = (e) => {
        setYear(e.target.value);
    };

    if (loading) {
        return <p>Loading chart...</p>;
    }

    if (error) {
        return <p>{error}</p>;
    }

    return (
        <div>
            {/*month and year dropdown for filtering*/}
            <div style={{marginBottom: '20px'}}>
                <label htmlFor="month">Select Month:</label>
                <select id="month" value={month} onChange={handleMonthChange}>
                    {[...Array(12)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                            {new Date(0, i, 1).toLocaleString('default', {month: 'long'})}
                        </option>
                    ))}
                </select>

                <label htmlFor="year" style={{ marginLeft: '10px'}}>Select Year:</label>
                <select id="year" value={year} onChange={handleYearChange}>
                    {[...Array(10)].map((_, i) => (
                        <option key={i + 1} value={new Date().getFullYear() - i}>
                            {new Date().getFullYear() - i}
                        </option>
                    ))}
                </select>
            </div>

            <div style={{ backgroundColor: '#f0f4f7', padding: '20px', borderRadius: '8px', maxWidth: '100%', height: '300px'}}>
            <Bar
                data={chartData}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            type: 'category',
                            title: {
                                display: true,
                                text: 'Days of the Month'
                            }
                        },
                        y: {
                            type: 'linear',
                            title: {
                                display: true,
                                text: 'Amount (Ksh)'
                            },
                            beginAtZero: true,
                        },
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: `Income and Expense for ${new Date(year, month - 1, 1)
                                .toLocaleString("default", {month: "long"})} ${year}`,
                            font: {
                                size: 18,
                            },
                        },
                        legend: {
                            display: true, // shows the legend or the key to the bar graph
                            position: 'top', // position of the legend
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    const value = context.raw || 0;
                                    return `Ksh ${value.toLocaleString()}`;
                                }
                            }
                        }
                    },
                }}
            />
            </div>
        </div>
    );
};

export default IncomeExpenseDailyChart;
